export default {
  required: 'Полето "{attribute}" е задължително.',
  email: 'Полето "{attribute}" трябва да съдържа валиден имейл адрес.',
  sameAs: 'Полето "{attribute}" трябва да е равно на {eq}.',
  minLength: 'Полето "{attribute}" трябва да е поне {min} символа.',
  checked: 'Полето "{attribute}" трябва да бъде избрано',
  minValue: 'Полето {attribute} трябва да е по-голямо от {min}.',
  minTicketValue: 'Въведи предположение за пробег различно от 0',
  numeric: 'Полето {attribute} трябва да съдържа само числа.',
  cardNumber: 'Полето {attribute} не съдържа валиден код от талон. Използвайте латински главни букви.',
  phone: 'Формата на телефона трябва да е +359876543210, без интервали',
  unique: 'Полетата {attribute} не може да се повтарят.'
}
